export const procCols = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号',
    },
    {
        title: '录入日期',
        en_title: 'Date Encoded',
        ch_title: '录入日期',
        dataIndex: '录入日期',
        sorter: (a, b) => a['录入日期'].localeCompare(b['录入日期']),
        renderFormItem: () => {
            return null;
        }
    },
    {
        title: '开立票据份数',
        en_title: 'Number of Ticket Issued',
        ch_title: '开立票据份数',
        dataIndex: '开立票据份数',
    },
    {
        title: '票据总额',
        en_title: 'Ticket Total Amount',
        ch_title: '票据总额',
        dataIndex: '票据总额',
    },
    {
        title: '地区',
        en_title: 'Region',
        ch_title: '地区',
        dataIndex: '地区',
        renderFormItem: () => {
            return null;
        }
    },
    {
        title: '操作人员',
        en_title: 'Operators',
        ch_title: '操作人员',
        dataIndex: '操作人员',
        renderFormItem: () => {
            return false;
        }
    },
    {
        title: '志工人数',
        en_title: 'Number of Volunteers',
        ch_title: '志工人数',
        dataIndex: '志工人数',
    },
    {
        title: '审核状态',
        en_title: 'Review status',
        ch_title: '审核状态',
        dataIndex: '审核状态',
        filters: [
            {
                text: '已审核',
                value: '已审核',
            },
            {
                text: '未审核',
                value: '未审核',
            },
        ],
        filterMode: 'tree',
        onFilter: (value, record) => record['审核状态'] == value,
        sorter: (a, b) => a['审核状态'].localeCompare(b['审核状态']),
    },
];
